import { apiOpen, apiUrl } from 'rise-ui/utils/external-api.js';
import { mapOpen, mapUrl } from 'rise-ui/utils/external-map.js';

export const linkActions = {
  api: { open: apiOpen, url: apiUrl },
  map: { open: mapOpen, url: mapUrl },
};

export function createLink(routeParams, options, elementId = undefined) {
  if (!routeParams.length) {
    return;
  }
  const { getDataKey, getOwner, setDidInsert } = options.data.root;
  const route = routeParams[0];
  const router = getOwner().lookup('service:router');
  elementId = elementId || getDataKey(options);

  const action = Object.entries(linkActions)
    .find(([ key ]) => key === route);

  let url;
  let external = options.hash.external;
  if (action) {
    url = action[1].url();
    external ||= action[1].external !== false;
  } else {
    url = router.urlFor(...routeParams);
  }

  setDidInsert(options, function(el) {
    el = document.getElementById(elementId);
    if (external && el.tagName === 'A') {
      return;
    }
    el.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (external) {
        window.open(url, '_blank');
      } else {
        router.transitionTo(...routeParams);
      }
    });
  });

  return { id: elementId, url, external };
}
